export default __webpack_public_path__ + "static/media/Whatsapp.437d456f.svg";